import { Injectable } from '@angular/core';
import { File } from '@app/models';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';
import * as AlarmActions from '@core/actions/alarm.actions';
import * as BrandActions from '@core/actions/brand.actions';
import {
  AddOne,
  DownloadColor,
  DownloadImg,
  DownloadImgFail,
  DownloadImgSuccess,
  DownloadOrderRecap,
  DownloadOrderRecapProvider,
  DownloadPosters,
  DownloadPostersFinal,
  DownloadQuery,
  DownloadRetroplanning,
  DownloadRetroplanningFail,
  DownloadRetroplanningSucces,
  ExportFinanceSummary,
  ExportFollow,
  ExportFollowSuccess,
  ExportGlobalOcm,
  ExportGlobalOcmComplete,
  ExportGlobalOcmFail,
  ExportHierarchyCountry,
  ExportImplantation,
  ExportMP,
  ExportMPSuccess,
  ExportMasterKey,
  ExportOcm,
  ExportOrderSummary,
  ExportOrderSummarySuccess,
  ExportProforma,
  ExportProviders,
  ExportProvidersSuccess,
  ExportTotalSupplier,
  FileActionTypes,
  GenerateTempLink,
  GenerateTemplateSuccess,
  GetLink,
  GetLinkFail,
  GetLinkHierarchyCountry,
  GetLinkHierarchyCountryFail,
  GetLinkHierarchyPlanner,
  GetLinkHierarchyPlannerFail,
  GetLinkHierarchyPlannerFood,
  GetLinkHierarchyPlannerFoodFail,
  GetLinkRetroplanning,
  GetLinkRetroplanningFail,
  LoadByProduct,
  LoadByProductFail,
  LoadByProductSuccess,
  Notify,
  Upload,
  UploadFail,
  UploadHierarchyCountry,
  UploadHierarchyCountryFail,
  UploadHierarchyCountrySuccess,
  UploadHierarchyCountryUpdate,
  UploadHierarchyCountryUpdateFail,
  UploadHierarchyCountryUpdateSuccess,
  UploadHierarchyPlanner,
  UploadHierarchyPlannerFail,
  UploadHierarchyPlannerFood,
  UploadHierarchyPlannerFoodFail,
  UploadHierarchyPlannerFoodSuccess,
  UploadHierarchyPlannerFoodUpdate,
  UploadHierarchyPlannerFoodUpdateFail,
  UploadHierarchyPlannerSuccess,
  UploadHierarchyPlannerUpdate,
  UploadHierarchyPlannerUpdateFail,
  UploadRetroplanning,
  UploadRetroplanningSuccess,
  UploadRetroplanningUpdateFail,
  UploadRetroplanningUpdateSuccess,
  UploadSingleImage,
  UploadSingleImageFail,
  UploadSingleImageFinalized,
  UploadSingleImageSecond,
  UploadSingleImageSecondSuccess,
  UploadSingleImageSuccess,
  UploadSuccess
} from '@core/actions/file.actions';
import * as MeActions from '@core/actions/me.actions';
import { LoadSingle } from '@core/actions/retroplanning.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  catchError,
  concatMap,
  delay,
  exhaustMap,
  map,
  switchMap,
  tap
} from 'rxjs/operators';

@Injectable()
export class FileEffects {
  @Effect()
  loadByProduct$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByProduct>(FileActionTypes.LoadByProduct),
    map(action => action.id),
    switchMap(id =>
      this.api.getProductFiles(id).pipe(
        map((files: File[]) => new LoadByProductSuccess(files)),
        catchError(error => of(new LoadByProductFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  exportMasterKey$ = this.actions$.pipe(
    ofType<ExportMasterKey>(FileActionTypes.ExportMasterKey),
    map(action => [action.name]),
    tap(([name]) =>
        this.api.exportMasterKey(name),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  downloadQuery$ = this.actions$.pipe(
    ofType<DownloadQuery>(FileActionTypes.DownloadQuery),
    map(action => [action.name, action.data]),
    tap(([name, data]) =>
        this.api.exportQuery(name, data),
      tap(() => console.log('done'))
    )
  )

  @Effect({ dispatch: false })
  exportMP$ = this.actions$.pipe(
    ofType<ExportMP>(FileActionTypes.ExportMP),
    map(action => [action.FollowId]),
    tap(([FollowId]) =>
        this.api.exportMP(FollowId),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportTotalSupplier$ = this.actions$.pipe(
    ofType<ExportTotalSupplier>(FileActionTypes.ExportTotalSupplier),
    map(action => [action.part]),
    tap(([part]) =>
        this.api.exportTotalSupplier(part),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportFollow$ = this.actions$.pipe(
    ofType<ExportFollow>(FileActionTypes.ExportFollow),
    map(action => [
      action.id,
      action.name,
      action.exportType,
      action.templateUniqId,
      action.filter
    ]),
    tap(
      ([id, name, type, templateUniqId, filter]) =>
        this.api.exportFollow(id, name, type, templateUniqId, filter),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportOrderSummary$ = this.actions$.pipe(
    ofType<ExportOrderSummary>(FileActionTypes.ExportOrderSummary),
    map(action => [
      action.followId,
    ]),
    tap(
      ([id]) =>
        this.api.exportOrderSummary(id),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportFinanceSummary$ = this.actions$.pipe(
    ofType<ExportFinanceSummary>(FileActionTypes.ExportFinanceSummary),
    map(action => [action.data]),
    tap(([id]) => this.api.exportFinanceSummaryXlsxl(id),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportOrderSummarySuccess$ = this.actions$.pipe(
    ofType<ExportOrderSummarySuccess>(FileActionTypes.ExportOrderSummarySuccess),
    map(action => {
      if (action.data !== undefined) {
        return this.api.downloadOrderSummary(action.data);
      }
      return
    })
  );
  // @Effect({ dispatch: false })
  // exportGlobalOcmSuccess$ = this.actions$.pipe(
  //   ofType<ExportGlobalOcmSuccess>(FileActionTypes.ExportGlobalOcmSuccess),
  //   map(action => action.data),
  //   tap(data => {
  //     this.fs.emit({
  //       type: 'success',
  //       message: 'Descargando...'
  //     });
  //   })
  // );

  @Effect({ dispatch: false })
  exportFollowSuccess$ = this.actions$.pipe(
    ofType<ExportFollowSuccess>(FileActionTypes.ExportFollowSuccess),
    map(action => {
      if (action.data !== undefined) {
        return this.api.downloadProductsImage(action.data);
      }
      return
    })
  );

  @Effect({ dispatch: false })
  exportGlobalOcmComplete$ = this.actions$.pipe(
    ofType<ExportGlobalOcmComplete>(FileActionTypes.ExportGlobalOcmComplete),
    map(action => {
      return this.api.downloadGlobalOCM(action.data);
    })
  );

  @Effect({ dispatch: false })
  exportGlobalOcmFail$ = this.actions$.pipe(
    ofType<ExportGlobalOcmFail>(FileActionTypes.ExportGlobalOcmFail),
    map(action => action.error),
    tap(error => {
      this.fs.emit({
        type: 'danger',
        message: error.message
      });
    })
  );

  @Effect({ dispatch: false })
  exportGlobalOcm$ = this.actions$.pipe(
    ofType<ExportGlobalOcm>(FileActionTypes.ExportGlobalOcm),
    map(action => [
      action.data
    ]),
    tap(
      ([data]) =>
        this.api.exportOCM(data),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportOcm$ = this.actions$.pipe(
    ofType<ExportOcm>(FileActionTypes.ExportOcm),
    map(action => [
      action.data
    ]),
    tap(
      ([data]) =>
        this.api.exportOCM(data),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  exportProforma$ = this.actions$.pipe(
    ofType<ExportProforma>(FileActionTypes.ExportProforma),
    map(action => action.data),
    tap(data => {
      const businessName = {
        SUPERMERCADOS: 'S',
        'MEJORAMIENTO DEL HOGAR': 'M',
        'TIENDA POR DEPARTAMENTO': 'T',
        'TXD PARIS': 'TP',
        'TXD JOHNSON': 'TJ',
        'MEJORAMIENTO DEL HOGAR BLAISTEN': 'MB'
      };
      const { id, name } = data;
      let providerName;
      const business = businessName[data.businessUnit];
      let countryName = data.Country.name.slice(0, 2);
      let portName = data.Port.name.slice(0, 8);

      if (data.Follow.type === 'VESTUARIO') {
        providerName = data.Provider.companyName.slice(0, 40);
      } else {
        providerName = data.Provider.name.slice(0, 40);
      }

      const factoryName = data.factory || '';
      // console.log('factoryName => ',factoryName)
      let nameFile;
      if (data && data.role && data.type !== "VESTUARIO") {
        nameFile = `${data.FollowId}-${data.Follow.year}-${
          data.Follow.Season.name
        }-${providerName}-${portName}-${business}-${countryName}`;
      } else if (data && data.role && data.type === "VESTUARIO") {
        countryName = data.Country.name.toUpperCase();
        portName = data.Port.name.toUpperCase();
        nameFile = `PZ-${
          data.Follow.Season.name
        }-${providerName}-${countryName}-${portName}`;
      }else {
        nameFile = `Proforma-${business}-${countryName}-${providerName}-${portName}`;
      }

      this.api.exportProforma(id, nameFile, null, data.Follow.ArrivalState);
    })
  );

  @Effect({ dispatch: false })
  downloadPosters$ = this.actions$.pipe(
    ofType<DownloadPosters>(FileActionTypes.DownloadPosters),
    map(action => action.data),
    tap(data => {
      this.api.exportPosters(data);
    })
  );

   @Effect({dispatch: false})
    downloadPostersFinal$ = this.actions$.pipe(
      ofType<DownloadPostersFinal>(FileActionTypes.DownloadPostersFinal),
      map(action => this.api.finishExportPosters(action.data, action.FollowId)),
    );

  @Effect({ dispatch: false })
  exportProviders$ = this.actions$.pipe(
    ofType<ExportProviders>(FileActionTypes.ExportProviders),
    map(action => action.data),
    tap(data => {
      this.api.exportProviders(data);
    })
  );

  @Effect({ dispatch: false })
  DownloadImg$ = this.actions$.pipe(
    ofType<DownloadImg>(FileActionTypes.DownloadImg),
    map(action => action.followId),
    tap(followId => {
      this.api.downloadImg(followId);
    })
  );

  @Effect({ dispatch: false })
  DownloadImgSuccess = this.actions$.pipe(
    ofType<DownloadImgSuccess>(FileActionTypes.DownloadImgSuccess),
    map(action => {
      if (action.data.message) {
        this.fs.emit({
          type: 'success',
          message: action.data.message
        });
      }
      if (action.data.downloadUrl && action.data.name) {
        this.api.downloadImgZip(action.data.downloadUrl, action.data.name);
      } else {
      }
    })
  );

  // @Effect({ dispatch: false })
  // DownloadImgUpdate = this.actions$.pipe(
  //   ofType<DownloadImgUpdate>(FileActionTypes.DownloadImgUpdate),
  //   map(action => {
  //     if(action.data && action.data.downloadUrl && action.data.name){
  //       this.api.downloadImgZip(action.data.downloadUrl, action.data.name)
  //     }
  //   })
  // );

  @Effect({ dispatch: false })
  DownloadImgFail$ = this.actions$.pipe(
    ofType<DownloadImgFail>(FileActionTypes.DownloadImgFail),
    map(action => action.error),
    tap(error => {
      this.fs.emit({
        type: 'danger',
        message: error.message
      });
    })
  );

  // RETROPLANNING

  @Effect({ dispatch: false })
  DownloadRetroplanning$ = this.actions$.pipe(
    ofType<DownloadRetroplanning>(FileActionTypes.DownloadRetroplanning),
    map(action => action.followId),
    tap(followId => {
      this.api.downloadRetroplanning(followId);
    })
  );

  @Effect({ dispatch: false })
  DownloadRetroplanningSuccess = this.actions$.pipe(
    ofType<DownloadRetroplanningSucces>(
      FileActionTypes.DownloadRetroplanningSucces
    ),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Descarga Retroplanning Completada'
      });
    })
  );

  @Effect({ dispatch: false })
  DownloadRetriplanningFail$ = this.actions$.pipe(
    ofType<DownloadRetroplanningFail>(
      FileActionTypes.DownloadRetroplanningFail
    ),
    map(action => action.error),
    tap(error => {
      this.fs.emit({
        type: 'danger',
        message: error.message
      });
    })
  );

  // UploadRetroplanning
  @Effect()
  getLinkRetroplanning: Observable<Action> = this.actions$.pipe(
    ofType<GetLinkRetroplanning>(FileActionTypes.GetLinkRetroplanning),
    map(action => [action.file, action.followId]),
    switchMap(([file, followId]) => {
      return this.api.getRetroplanningUploadLink(followId, file).pipe(
        map((record: any) => {
          return new UploadRetroplanning(
            record.signedUrl,
            record.id,
            file,
            followId
          );
        }),
        catchError(e => of(new GetLinkRetroplanningFail()))
      );
    })
  );

  @Effect()
  uploadRetroplanning$: Observable<Action> = this.actions$.pipe(
    ofType<UploadRetroplanning>(FileActionTypes.UploadRetroplanning),
    map(action => [
      action.uploadUrl,
      action.FileId,
      action.file,
      action.followId
    ]),
    switchMap(([uploadUrl, FileId, file, followId]) => {
      return this.api.uploadFile(uploadUrl, file).pipe(
        map(record => {
          return new UploadRetroplanningSuccess(FileId, followId);
        }),
        catchError(e => of(new UploadRetroplanningUpdateFail()))
      );
    })
  );

  @Effect()
  uploadSingleImage$ = this.actions$.pipe(
    ofType<UploadSingleImage>(
      FileActionTypes.UploadSingleImage
    ),
    map(action => action),
    exhaustMap((action) => {
      const data = action.data
      const productId = action.productId
      const followId = action.followId
      const position = action.position
      return this.api.uploadSingleImage(data, productId, followId, position).pipe(
        concatMap((response: string) => {
          return [new UploadSingleImageSuccess(response, data)];
        }),
        catchError(e => {
          return of(new UploadSingleImageFail(e));
        })
      );
    })
  );

  @Effect()
  uploadSinleImageSuccess$ = this.actions$.pipe(
    ofType<UploadSingleImageSuccess>(
      FileActionTypes.UploadSingleImageSuccess
    ),
    map(action => [action.link, action.file]),
    switchMap(([link, file]) => {
      return this.api.uploadFile(link.signedUrl, file).pipe(
        map(record => {
          return new UploadSingleImageSecond(link.id);
        }),
        catchError(e => of(new UploadSingleImageFail(e)))
      );
    })
  );

  @Effect()
  uploadSingleImageSecond$ = this.actions$.pipe(
    ofType<UploadSingleImageSecond>(
      FileActionTypes.UploadSingleImageSecond
    ),
    map(action => action),
    exhaustMap((action) => {
      return this.api.uploadSingleImageSecond(action.fileId).pipe(
        map((response: string) => {
          return new UploadSingleImageFinalized()
        }),
        catchError(e => {
          return of(new UploadSingleImageFail(e));
        })
      );
    })
  );


  @Effect()
  uploadRetroplanningSuccess$ = this.actions$.pipe(
    ofType<UploadRetroplanningSuccess>(
      FileActionTypes.UploadRetroplanningSuccess
    ),
    map(action => [action.FileId, action.followId]),
    switchMap(([FileId, followId]) => {
      const metadata = { processType: 'Retroplanning' };
      return this.api.notifyFileUpload(FileId, metadata).pipe(
        map(record => {
          return new UploadRetroplanningUpdateSuccess(followId);
        }),
        delay(2000),
        catchError(e => of(new UploadRetroplanningUpdateFail()))
      );
    })
  );

  // @Effect({ dispatch: false })
  @Effect()
  uploadRetroplanningUpdateSuccess$ = this.actions$.pipe(
    ofType<UploadRetroplanningUpdateSuccess>(
      FileActionTypes.UploadRetroplanningUpdateSuccess
    ),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Retroplanning actualizado'
      });
      // window.location.reload();
      return new LoadSingle(action.followId);
    })
    // delay(2000)
  );

  @Effect({ dispatch: false })
  uploadSingleImageSecondSuccess$ = this.actions$.pipe(
    ofType<UploadSingleImageSecondSuccess>(
      FileActionTypes.UploadSingleImageSecondSuccess
    ),
    map(() => {
      this.fs.emit({
        type: 'success',
        message: 'Imagen actualizada'
      });
    })
  );

  @Effect()
  uploadRetroplanningUpdateFail$ = this.actions$.pipe(
    ofType<UploadRetroplanningUpdateFail>(
      FileActionTypes.UploadRetroplanningUpdateFail
    ),
    map(() => {
      this.fs.emit({
        type: 'danger',
        message: 'Error al actualizar el retroplanning'
      });
    })
  );

  @Effect()
  uploadSingleImageFail$ = this.actions$.pipe(
    ofType<UploadSingleImageFail>(
      FileActionTypes.UploadSingleImageFail
    ),
    map(() => {
      this.fs.emit({
        type: 'danger',
        message: 'Error al actualizar la imagen'
      });
    })
  );

  @Effect({ dispatch: false })
  exportHierarchyCountry$ = this.actions$.pipe(
    ofType<ExportHierarchyCountry>(FileActionTypes.ExportHierarchyCountry),
    map(action => action.data),
    tap(data => {
      this.api.exportHierarchyCountry(data);
    })
  );

  @Effect({ dispatch: false })
  exportHierarchyPlanner$ = this.actions$.pipe(
    ofType<ExportHierarchyCountry>(FileActionTypes.ExportHierarchyPlanner),
    map(action => action.data),
    tap(data => {
      this.api.exportHierarchyPlanner(data);
    })
  );

  @Effect({ dispatch: false })
  exportHierarchyPlannerFood$ = this.actions$.pipe(
    ofType<ExportHierarchyCountry>(FileActionTypes.ExportHierarchyPlannerFood),
    map(action => action.data),
    tap(data => {
      this.api.exportHierarchyPlannerFood(data);
    })
  );

  @Effect()
  getLink$ = this.actions$.pipe(
    ofType<GetLink>(FileActionTypes.GetLink),
    map(action => [action.owner, action.file, action.featured]),
    exhaustMap(([owner, file, featured]) =>
      this.api.getFileUploadLink(owner, file, featured).pipe(
        concatMap((link: any) => {
          return [new Upload(link, file)];
        }),
        catchError(error => of(new GetLinkFail(error)))
      )
    )
  );

  @Effect()
  uploadFile$ = this.actions$.pipe(
    ofType<Upload>(FileActionTypes.Upload),
    map(action => [action.link, action.file]),
    exhaustMap(([link, file]: [any, any]) => {
      const url = link.signedUrl;
      const fileId = link.id;
      return this.api.uploadFile(url, file).pipe(
        concatMap(response => {
          return [new Notify(fileId)];
        }),
        catchError(error => {
          return of(new UploadFail(error));
        })
      );
    })
  );

  @Effect()
  notifyFileUpload$ = this.actions$.pipe(
    ofType<Notify>(FileActionTypes.Notify),
    map(action => action.id),
    exhaustMap(id => {
      return this.api.notifyFileUpload(id).pipe(
        concatMap((file: File) => {
          if(file['FileableType'] === "CatalogueFrontPage"){
            this.fs.emit({
              type: 'success',
              message: 'Imagen Cargada!'
            });
          }
          return [
            new UploadSuccess(),
            new AddOne(file),
            file.BrandId
              ? new BrandActions.AddPicture(file)
              : file.AlarmId
              ? new AlarmActions.AddPicture(file)
              : file.UserId
              ? new MeActions.UpdateAvatar(file)
              : new UploadSuccess()
          ];
        }),
        catchError(error => {
          return of(new UploadFail(error));
        })
      );
    })
  );

  @Effect({ dispatch: false })
  exportImplantation$ = this.actions$.pipe(
    ofType<ExportImplantation>(FileActionTypes.ExportImplantation),
    map(action => [action.FollowId]),
    tap(([FollowId]) => {
      this.api.exportImplantation(FollowId);
    })
  );

  @Effect({ dispatch: false })
  downloadOrderRecap$ = this.actions$.pipe(
    ofType<DownloadOrderRecap>(FileActionTypes.DownloadOrderRecap),
    map(action => [action.followId]),
    tap(([FollowId]) => {
      this.api.exportOrderRecap(FollowId);
    })
  );

  @Effect({ dispatch: false })
  downloadOrderRecapProvider$ = this.actions$.pipe(
    ofType<DownloadOrderRecapProvider>(FileActionTypes.DownloadOrderRecapProvider),
    map(action => [action.followId]),
    tap(([FollowId]) => {
      this.api.exportOrderRecapProvider(FollowId);
    })
  );

  @Effect()
  getLinkHierarchyCountry: Observable<Action> = this.actions$.pipe(
    ofType<GetLinkHierarchyCountry>(FileActionTypes.GetLinkHierarchyCountry),
    map(action => action.file),
    switchMap(file => {
      return this.api.getHierarchyCountryUploadLink(file).pipe(
        map((record: any) => {
          return new UploadHierarchyCountry(record.signedUrl, record.id, file);
        }),
        catchError(e => of(new GetLinkHierarchyCountryFail()))
      );
    })
  );

  @Effect()
  uploadHierarchyCountry$: Observable<Action> = this.actions$.pipe(
    ofType<UploadHierarchyCountry>(FileActionTypes.UploadHierarchyCountry),
    map(action => [action.uploadUrl, action.FileId, action.file]),
    switchMap(([uploadUrl, FileId, file]) => {
      return this.api.uploadFile(uploadUrl, file).pipe(
        map(record => {
          return new UploadHierarchyCountrySuccess(FileId);
        }),
        catchError(e => of(new UploadHierarchyCountryFail()))
      );
    })
  );

  @Effect()
  uploadHierarchyCountrySuccess$ = this.actions$.pipe(
    ofType<UploadHierarchyCountrySuccess>(
      FileActionTypes.UploadHierarchyCountrySuccess
    ),
    map(action => action.FileId),
    switchMap((FileId: number) => {
      const metadata = { processType: 'Hierarchy Country' };
      // console.log('Effect', metadata);
      return this.api.notifyFileUpload(FileId, metadata).pipe(
        map(record => {
          return new UploadHierarchyCountryUpdate({
            status: 'pending',
            message: 'Procesando Jerarquía País...'
          });
        }),
        catchError(e => of(new UploadHierarchyCountryUpdateFail()))
      );
    })
  );

  @Effect({ dispatch: false })
  uploadHierarchyCountryUpdateSuccess$ = this.actions$.pipe(
    ofType<UploadHierarchyCountryUpdateSuccess>(
      FileActionTypes.UploadHierarchyCountryUpdateSuccess
    ),
    map(() => {
      this.fs.emit({
        type: 'success',
        message: 'Jerarquía País actualizada'
      });
    })
  );

  @Effect()
  uploadHierarchyCountryUpdateFail$ = this.actions$.pipe(
    ofType<UploadHierarchyCountryUpdateFail>(
      FileActionTypes.UploadHierarchyCountryUpdateFail
    ),
    map(() => {
      this.fs.emit({
        type: 'danger',
        message: 'Error al actualizar Jerarquía País'
      });
    })
  );

  // Hierarchy Planner

  @Effect()
  getLinkHierarchyPlanner: Observable<Action> = this.actions$.pipe(
    ofType<GetLinkHierarchyPlanner>(FileActionTypes.GetLinkHierarchyPlanner),
    map(action => action.file),
    switchMap(file => {
      return this.api.getHierarchyPlannerUploadLink(file).pipe(
        map((record: any) => {
          return new UploadHierarchyPlanner(record.signedUrl, record.id, file);
        }),
        catchError(e => of(new GetLinkHierarchyPlannerFail()))
      );
    })
  );

  @Effect()
  getLinkHierarchyPlannerFood: Observable<Action> = this.actions$.pipe(
    ofType<GetLinkHierarchyPlannerFood>(FileActionTypes.GetLinkHierarchyPlannerFood),
    map(action => action.file),
    switchMap(file => {
      return this.api.getHierarchyPlannerFoodUploadLink(file).pipe(
        map((record: any) => {
          return new UploadHierarchyPlannerFood(record.signedUrl, record.id, file);
        }),
        catchError(e => of(new GetLinkHierarchyPlannerFoodFail()))
      );
    })
  );

  @Effect()
  uploadHierarchyPlanner$: Observable<Action> = this.actions$.pipe(
    ofType<UploadHierarchyPlanner>(FileActionTypes.UploadHierarchyPlanner),
    map(action => [action.uploadUrl, action.FileId, action.file]),
    switchMap(([uploadUrl, FileId, file]) => {
      return this.api.uploadFile(uploadUrl, file).pipe(
        map(record => {
          return new UploadHierarchyPlannerSuccess(FileId);
        }),
        catchError(e => of(new UploadHierarchyPlannerFail()))
      );
    })
  );

  @Effect()
  uploadHierarchyPlannerSuccess$ = this.actions$.pipe(
    ofType<UploadHierarchyPlannerSuccess>(
      FileActionTypes.UploadHierarchyPlannerSuccess
    ),
    map(action => action.FileId),
    switchMap((FileId: number) => {
      const metadata = { processType: 'Hierarchy Planner' };
      // console.log('Effect', metadata);
      return this.api.notifyFileUpload(FileId, metadata).pipe(
        map(record => {
          return new UploadHierarchyPlannerUpdate({
            status: 'pending',
            message: 'Procesando Jerarquía País...'
          });
        }),
        catchError(e => of(new UploadHierarchyPlannerUpdateFail()))
      );
    })
  );

  @Effect()
  uploadHierarchyPlannerFood$: Observable<Action> = this.actions$.pipe(
    ofType<UploadHierarchyPlannerFood>(FileActionTypes.UploadHierarchyPlannerFood),
    map(action => [action.uploadUrl, action.FileId, action.file]),
    switchMap(([uploadUrl, FileId, file]) => {
      return this.api.uploadFile(uploadUrl, file).pipe(
        map(record => {
          return new UploadHierarchyPlannerFoodSuccess(FileId);
        }),
        catchError(e => of(new UploadHierarchyPlannerFoodFail()))
      );
    })
  );

  @Effect()
  uploadHierarchyPlannerFoodSuccess$ = this.actions$.pipe(
    ofType<UploadHierarchyPlannerFoodSuccess>(
      FileActionTypes.UploadHierarchyPlannerFoodSuccess
    ),
    map(action => action.FileId),
    switchMap((FileId: number) => {
      const metadata = { processType: 'HierarchyPlannerFood' };
      return this.api.notifyFileUpload(FileId, metadata).pipe(
        map(record => {
          return new UploadHierarchyPlannerFoodUpdate({
            status: 'pending',
            message: 'Procesando Jerarquía Food...'
          });
        }),
        catchError(e => of(new UploadHierarchyPlannerFoodUpdateFail()))
      );
    })
  );

  @Effect({ dispatch: false })
  downloadColor$ = this.actions$.pipe(
    ofType<DownloadColor>(FileActionTypes.DownloadColor),
    map(action => [action.FileId, action.FollowId]),
    tap(
      ([FileId, FollowId]) => this.api.downloadNewColor(FileId, FollowId),
      tap(() => console.log('done'))
    )
  );

  @Effect({ dispatch: false })
  generateTemplateSuccess$ = this.actions$.pipe(
    ofType<GenerateTemplateSuccess>(FileActionTypes.GenerateTemplateSuccess),
    map(action => {
      return this.api.downloadTemplate(action.data);
    })
  );

  @Effect({ dispatch: false })
  exportMPSuccess$ = this.actions$.pipe(
    ofType<ExportMPSuccess>(FileActionTypes.ExportMPSuccess),
    map(action => {
      return this.api.downloadMPTemplate(action.data);
    })
  );

  @Effect({ dispatch: false})
  generateTempLink$ = this.actions$.pipe(
    ofType<GenerateTempLink>(FileActionTypes.GenerateTempLink),
    map(action => {
      return this.api.generateTempLink(action.data, action.fileName)
    })
  )


  @Effect({ dispatch: false })
  exportProvidersSuccess$ = this.actions$.pipe(
    ofType<ExportProvidersSuccess>(FileActionTypes.ExportProvidersSuccess),
    map(action => {
      return this.api.downloadTemplate(action.data);
    })
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService
  ) {}
}
